/**
 * Communication Systems Lesson
 * Skill Area: Communication
 * Build reusable AI-powered templates
 */

import type { LessonDefinition } from '../types';
import { COMMUNICATION_SYSTEMS_AI_PROMPT, COMMUNICATION_SYSTEMS_CONTEXT_SCENARIOS } from '../prompts/communication-systems.prompt';

export const communicationSystems: LessonDefinition = {
  id: 'communication-systems',
  title: 'Communication Systems',
  displayTitle: 'Build Reusable AI-Powered Templates',
  subTitle: 'Build reusable AI-powered templates',
  persona: 'Lyra',
  skillArea: 'Communication',
  topicId: 'communication-quality',
  topicTitle: 'Communication Quality & Voice',
  topicDescription: 'Verify outputs, keep your voice authentic, and build reusable comms systems.',
  format: 'tool_lab',
  difficulty: 'Intermediate',
  estimatedMinutes: 7,
  tags: ['systems', 'templates', 'automation'],
  dailyEligible: true,
  releasedAt: '2025-01-19T00:00:00.000Z',
  route: '/micro/communication-systems',
  storyBeat: 'Systematize communications to save hours weekly.',
  introPrompt: "You're rewriting the same emails from scratch every single time. That's not a writing problem—it's a systems problem. Let's fix it.",
  steps: [
    "Identify a communication you rewrite constantly",
    "Learn the three layers of a reusable template",
    "Build your first Communication Template",
    "Practice on a second communication type"
  ],
  promptGuidance: 'Choose a communication type below or type your own.',
  contextScenarios: COMMUNICATION_SYSTEMS_CONTEXT_SCENARIOS,
  aiPrompt: COMMUNICATION_SYSTEMS_AI_PROMPT,
  inputPlaceholder: "e.g., Donor thank-yous, Meeting recaps...",
  quickPrompts: [
    'Donor thank-you notes',
    'Meeting recap emails',
    'Event reminder sequences',
    'Program update emails'
  ]
};
